const COMMON_WEAK_TERMS = [
  '123456',
  '12345678',
  'password',
  'passw0rd',
  'qwerty',
  'letmein',
  'welcome',
  'changeme',
  'admin',
  'administrator',
  'manager',
  'sales',
  'driver',
  'owner',
  'user',
  'flintpos',
];

function normalizeTerm(value) {
  return String(value || '').toLowerCase().replace(/[^a-z0-9]/g, '');
}

function contextTerms(context = {}) {
  const terms = [];
  const add = (value) => {
    const normalized = normalizeTerm(value);
    if (normalized.length >= 4) terms.push(normalized);
  };

  add(context.username);
  add(context.email && String(context.email).split('@')[0]);
  add(context.storeName);
  add(context.companyName);
  String(context.name || '')
    .split(/\s+/)
    .forEach(add);

  return Array.from(new Set(terms));
}

export function validatePasswordPolicy(password, context = {}) {
  const value = String(password || '');
  const compact = normalizeTerm(value);
  const errors = [];
  const classes = [
    /[a-z]/i.test(value),
    /\d/.test(value),
    /[^a-z0-9]/i.test(value),
  ].filter(Boolean).length;

  if (value.length < 8) errors.push('Use at least 8 characters.');
  if (value.length > 72) errors.push('Use 72 characters or fewer.');
  if (classes < 2) errors.push('Use at least two of: letters, numbers, or symbols.');
  if (/(.)\1{5,}/.test(value)) errors.push('Avoid long repeated character runs.');
  if (COMMON_WEAK_TERMS.some((term) => compact.includes(term))) {
    errors.push('Do not use obvious words like admin, password, or FlintPOS.');
  }
  if (contextTerms(context).some((term) => compact.includes(term))) {
    errors.push('Do not include the username, name, email, or store name.');
  }

  return { valid: errors.length === 0, errors, message: errors[0] || '' };
}

export const PASSWORD_POLICY_HELP = 'At least 8 characters, with two of letters, numbers, or symbols. Do not use admin, password, FlintPOS, or the user name.';
